export default __webpack_public_path__ + "static/media/cgiar_neww.240b4ee5.svg";